import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { CategoriesResponseDTO } from '../ducks/types';

export const categoriesApiV2 = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 60000 });

const getCategoriesApi = async (): Promise<CategoriesResponseDTO> => {
  const response = await categoriesApiV2.api.get<CategoriesResponseDTO>('api/v2/categories');
  const { groups, categories } = response.data || { groups: [], categories: [] };

  return { groups: groups || [], categories: categories || [] };
};

export default getCategoriesApi;
